import classNames from 'classnames';
import PropTypes from 'prop-types';
import React from 'react';
import Select from 'react-select';

import { topBarSelectStyles, FilledTriangleDropdownIndicator } from '../select-field-editor/selectStyles.jsx';
import s from './VisitorInsightsTopBar.module.scss';

// VenueSelector Subcomponent ------------------------------------------------------------------------------------------
// Drop-down list of venues at the left of the TopBar
const ConfigSelector = ({ configs, onConfigSelect, configId }) => {
    const options = configs.map(config => ({ value: config.id, label: config.name }));
    const selectedOption = options.find(option => option.value === configId);

    return (
        <div className={s.selectWrapper} data-testid="config-selector">
            <Select
                isClearable={false}
                options={options}
                value={selectedOption}
                onChange={option => onConfigSelect(option.value)}
                styles={topBarSelectStyles}
                components={{ DropdownIndicator: FilledTriangleDropdownIndicator }}
            />
        </div>
    );
};

ConfigSelector.propTypes = {
    configId: PropTypes.string,
    configs: PropTypes.arrayOf(PropTypes.object).isRequired,
    onConfigSelect: PropTypes.func.isRequired,
};

ConfigSelector.defaultProps = { configId: '' };

// TopBar Component ----------------------------------------------------------------------------------------------------
// Component showing VenueSelector, ViewSelector and various possibilities on the right
const VisitorInsightsTopBar = ({ onConfigSelect, configs, configId }) => (
    <div className={s.topBar}>
        <ConfigSelector configId={configId} configs={configs} onConfigSelect={onConfigSelect} />

        <div className={s.logoWrapper}>
            <div className={s.locusLogo} />
        </div>
    </div>
);

VisitorInsightsTopBar.propTypes = {
    configId: PropTypes.string,
    configs: PropTypes.arrayOf(PropTypes.object).isRequired,
    onConfigSelect: PropTypes.func.isRequired,
};

VisitorInsightsTopBar.defaultProps = { configId: '' };

export default VisitorInsightsTopBar;
